module.exports = __webpack_public_path__ + "img/img1.c3b82502.png";